import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type SessionInfo = {
  csrfTokenValue?: string;
  usePPD?: boolean;
  isGuest?: boolean;
  timeout?: number;
  id?: number;
  uid?: string;
  username?: string;
  email?: string;
  geo?: {
    countryIso?: string | null;
    countryName?: string | null;
  };
};

export type SessionState = {
  csrfToken?: string;
  csrfTokenName?: string; // kept for backward compat; will be undefined going forward
  isGuest?: boolean;
  setCsrf: (name: string | undefined, value: string | undefined) => void;
  setIsGuest: (value: boolean | undefined) => void;
  reset: () => void;
};

export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      csrfToken: undefined,
      csrfTokenName: undefined,
      isGuest: undefined,
      setCsrf: (name, value) => set(() => ({ csrfTokenName: name, csrfToken: value })),
      setIsGuest: (value) => set(() => ({ isGuest: value })),
      reset: () => set(() => ({ csrfToken: undefined, csrfTokenName: undefined, isGuest: undefined })),
    }),
    {
      name: 'session-store',
      partialize: (state) => ({ csrfToken: state.csrfToken, csrfTokenName: state.csrfTokenName, isGuest: state.isGuest }),
    }
  )
);
